<template lang="pug">
  div
    .visual-title.-xs.-white(:style="`background-image: url(${titleBgImage});`")
      .title
        i.h1rem
          LogoYaneSvg
        h1.heading2 初回限定おためし商品
        .heading3.curve-bottom One Time
    .archives-description
      p お一人様一回限り。初めての方限定の商品です。まだ食べたことが無い方へ、お得にお試し頂けます。

    ItemFilterBlock
      DropDown(@change="$_changeOrder" v-model="pageInfo.orderBy" :options="$_orderDropDownOptions")
      .stock-checkbok
        FormCheckbox(@change="$_changeStockFilter" v-model="stockOnly") 販売中のみ表示

    ItemCardList
      .item.lg(v-for="(itemGroup, index) in itemGroups" :key="itemGroup.id")
        ItemCard(:itemGroup="itemGroup" eventCategory="商品一覧" pageContents="商品一覧")
    .row
      .col-xs-12(v-if="itemGroups.length === 0")
        .success-notice
          .text-center 商品がありません。
      .col-xs-12
        Pager(@change="$_changePage" :custom-page-info="$_customPageInfo")

    SectionItemArchive
</template>

<script>
  import {GetItemGroupsForApi} from "../../graphqls/ItemGroups";

  import LogoYaneSvg from "../../components/svg/LogoYaneSvg";
  import ItemList from "../../components/list/ItemList";
  import GlobalMixin from "../../mixin/GlobalMixin";
  import Pager from "../../components/paginate/Pager";
  import DropDown from "../../components/v1/dropdown/DropDown";
  import ItemListMixin from "../../mixin/ItemListMixin";
  import ItemCardList from "../../components/v1/item/ItemCardList";
  import ItemCard from "../../components/v1/item/ItemCardForApi";
  import SectionItemArchive from "../../components/v1/section/SectionItemArchive";
  import ItemFilterBlock from "../../components/v1/item/ItemFilterBlock";
  import FormCheckbox from "../../components/v1/form/FormCheckbox";

  export default {
    name: "onetime-items-index",
    mixins: [GlobalMixin, ItemListMixin],
    components: {
      FormCheckbox,
      ItemFilterBlock,
      SectionItemArchive,
      ItemCard,
      ItemCardList,
      DropDown,
      Pager,
      ItemList,
      LogoYaneSvg
    },
    props: [],
    data() {
      return {
        itemGroups: [],
        pageInfo: {
          currentPage:  Number(this.$route.params.page || 1),
          totalCount: 0,
          perPage: 48,
          orderBy: this.$route.query.order || 'popular'
        },
        stockOnly: this.$route.query?.stock === 'instock',
        withinYearItem: this.$route.query.wiy === 'true',
        firstItemGroup: {ogpImageUrl: ''}
      }
    },
    computed: {
      titleBgImage() {
        if (this.firstItemGroup.ogpImageUrl) {
          return this.firstItemGroup.ogpImageUrl
        } else {
          return ''
        }
      },
      topRouterName() {
        return 'onetime-items-index'
      },
      pageRouterName() {
        return 'onetime-items-page-index'
      },
      stockFilter() {
        return this.stockOnly ? 'instock' : 'outstock'
      }
    },
    mounted() {
      this.fetchItemGroups()
    },
    methods: {
      async fetchItemGroups() {
        this.loadingStart();
        const { data } = await this.$apollo
        .query({
          query: GetItemGroupsForApi,
          variables: {
            onetimeItem: true,
            stockFilter: this.stockFilter,
            withinYearItem: this.withinYearItem,
            ...this.pageInfo
          },
          client: 'apiClient'
        })
        .catch(error => {
          this.loadingStop()
          return;
        });
        this.itemGroups = data.itemGroups.items;
        this.pageInfo = data.itemGroups.pageInfo
        this.loadingStop();
        this.$_gaSendViewItemList(this.itemGroups, 'shops/items/onetime', this.pageInfo)
      },
      updateItemGroup(newItemGroup) {
        if (this.itemGroups[0].id === newItemGroup.id) {
          this.firstItemGroup = newItemGroup
        }
      }
    }
  }
</script>

<style scoped lang="scss">
</style>
